import { Geocode } from './geocode';

export class BoundingRadius {
    CenterPoint: Geocode;
    Distance: number;
    ClientID: string;
    Name: string;
    GroupID: string;
}


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/pharmacy-locator/models/BoundingRadius.ts